import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSavedPromptStore = defineStore('savedPrompt', () => {
    const selectedPromptContent = ref<string | null>(null);
    const shouldEmptyInput = ref<boolean>(false);
    const shouldInsertPrompt = ref<boolean>(false);

    return {
        selectedPromptContent,
        shouldEmptyInput,
        shouldInsertPrompt
    };
});
